import { createRoot } from "react-dom/client";
import Content from "./Content";
import Footer from "./Footer";
import Frame from "./Frame";
import Header from "./Header";
import Action from "./components/Action";
import ActionBar from "./components/ActionBar";
import Breadcrumb from "./components/Breadcrumb";
import BreadcrumbPart from "./components/BreadcrumbPart";
import { AppModelImpl } from "./model/AppModel";
import { LoadingState } from "./model/models";
import SideNav from "./sidenav/SideNav";
import SideNavElement from "./sidenav/SideNavElement";
import ErrorTemplate from "./templates/ErrorTemplate";
import TopNav from "./topnav/TopNav";
import TopNavRightElement from "./topnav/TopNavRightElement";
import { getConfig } from "./utils/config";
import { createSupportContext, createSupportMailTo, createSupportMailToForContext, registerCompatSupportMailTo, } from "./utils/customerSupport";
export function createAppModel(props) {
    return new AppModelImpl(props);
}
export function start(rootComponent) {
    var initialized = false;
    const callback = (elements) => {
        if (initialized) {
            console.log("Rendering already started, skipping: %s", elements.source);
            return true;
        }
        else if (elements.appFrameMountPoint) {
            initialized = true;
            console.log("Start rendering from: %s", elements.source);
            registerCompatSupportMailTo();
            elements.appFrameMountPoint.style.display = "flex"; // keep in sync with .zebdshappframe from _base.scss
            if (elements.hourglass) {
                elements.hourglass.style.display = "none";
            }
            const root = createRoot(elements.appFrameMountPoint);
            root.render(rootComponent);
            return true;
        }
        else {
            console.log("Cannot start rendering from: %s", elements.source);
            return false;
        }
    };
    document.addEventListener("DOMContentLoaded", function (event) {
        const elements = {
            hourglass: document.getElementById("zebDshAppHourglass"),
            appFrameMountPoint: document.getElementById("zebDshAppFrame"),
            source: "event",
        };
        if (callback(elements) == false) {
            throw "Rendering of app failed";
        }
    });
    // either dom is fully loaded and getElementById finds the elements,
    // or the dom is not yet fully loaded and then the event above will be reached
    const elements = {
        hourglass: document.getElementById("zebDshAppHourglass"),
        appFrameMountPoint: document.getElementById("zebDshAppFrame"),
        source: "main",
    };
    callback(elements);
}
export { Action, ActionBar, Breadcrumb, BreadcrumbPart, Content, ErrorTemplate, Footer, Frame, Header, LoadingState, SideNav, SideNavElement, TopNav, TopNavRightElement, createSupportContext, createSupportMailTo, createSupportMailToForContext, getConfig, };
